import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, catchError, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FlightSchoolResponse } from '@fsp-lib/discovery-flights';

@Injectable({
  providedIn: 'root',
})
export class OperatorService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getOperator(operatorId: string): Observable<FlightSchoolResponse> {
    const url = `${this.apiUrl}/flightschools/${operatorId}`;
    return this.http.get<FlightSchoolResponse>(url).pipe(
      map((response) => response),
      catchError((error) => {
        console.error(
          `Error fetching flight school with ID: ${operatorId}`,
          error,
        );
        throw error;
      }),
    );
  }
}
